import TspApiService from "../api/tspApiService";
import useTspApiResource from "./useTspApiResource";
import { GEOCODE_STATE, geocodeMessage, geocodeState } from "../pages/journeys/mapPickModel";

const NOTHING = Promise.resolve({ data: null });

// Resolves a map point to its place through the TSP API (never a provider
// directly): { state, data, message, retry }. A new point replaces the previous
// lookup, and a late answer for an earlier point is dropped (useTspApiResource).
//
//   point     { latitude, longitude } or null
//   enabled   false = never ask (e.g. the caller may not create journeys)
//   initial   an answer already fetched for this same point (handed over by
//             the map), used instead of asking again
export default function useTspReverseGeocode(point, { enabled = true, initial = null } = {}) {
  const reuse = Boolean(point && initial && initial.latitude === point.latitude && initial.longitude === point.longitude);
  const ask = Boolean(enabled && point && !reuse);
  const resource = useTspApiResource(() => (ask ? TspApiService.reverseGeocode(point) : NOTHING), [ask, point?.latitude, point?.longitude]);

  if (!enabled || !point) return { state: GEOCODE_STATE.idle, data: null, message: "", retry: resource.reload };
  const data = reuse ? initial : resource.data;
  const state = reuse ? geocodeState({ point, loading: false, error: null, data }) : geocodeState({ point, ...resource });
  return { state, data, message: geocodeMessage(state), retry: resource.reload };
}
